export default __webpack_public_path__ + "static/media/solid_security_number.5552770d.svg";